"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardFooter = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _CardContent = require("./CardContent");

var CardFooter = function CardFooter(props) {
  return /*#__PURE__*/_react["default"].createElement(_CardContent.CardContent, (0, _extends2["default"])({
    footer: true
  }, props));
};

exports.CardFooter = CardFooter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDYXJkRm9vdGVyIiwicHJvcHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9DYXJkL0NhcmRGb290ZXIudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IENhcmRDb250ZW50IH0gZnJvbSAnLi9DYXJkQ29udGVudCc7XG5cbmludGVyZmFjZSBQcm9wcyBleHRlbmRzIFJlYWN0LkNvbXBvbmVudFByb3BzPHR5cGVvZiBDYXJkQ29udGVudD4ge31cblxuZXhwb3J0IGNvbnN0IENhcmRGb290ZXI6IFJlYWN0LkZDPFJlYWN0LlByb3BzV2l0aENoaWxkcmVuPFByb3BzPj4gPSAocHJvcHMpID0+IChcbiAgPENhcmRDb250ZW50IGZvb3RlciB7Li4ucHJvcHN9IC8+XG4pO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOztBQUVBOztBQUlPLElBQU1BLFVBQW9ELEdBQUcsU0FBdkRBLFVBQXVELENBQUNDLEtBQUQ7RUFBQSxvQkFDbEUsZ0NBQUMsd0JBQUQ7SUFBYSxNQUFNO0VBQW5CLEdBQXdCQSxLQUF4QixFQURrRTtBQUFBLENBQTdEIn0=